'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _doctifyStarRating = require('../../src/styles/doctify-star-rating.scss');

var _doctifyStarRating2 = _interopRequireDefault(_doctifyStarRating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Star = function Star() {
	return _react2.default.createElement('span', { className: _doctifyStarRating2.default.fullStar });
};

var HalfStar = function HalfStar() {
	return _react2.default.createElement('span', { className: _doctifyStarRating2.default.halfStar });
};

var StarOutline = function StarOutline() {
	return _react2.default.createElement('span', { className: _doctifyStarRating2.default.star });
};

var DoctifyStarRating = function DoctifyStarRating(props) {
	var rating = props.rating,
	    maxStars = props.maxStars;


	var totalStars = Math.ceil(rating);
	var containsHalfStar = !!(rating % 1);
	var stars = [];

	for (var i = 0; i < maxStars; i++) {
		if (i === totalStars - 1 && containsHalfStar) {
			stars.push(_react2.default.createElement(HalfStar, { key: i }));
		} else if (i < totalStars) {
			stars.push(_react2.default.createElement(Star, { key: i }));
		} else {
			stars.push(_react2.default.createElement(StarOutline, { key: i }));
		}
	}

	return _react2.default.createElement(
		'div',
		null,
		stars
	);
};

DoctifyStarRating.propTypes = {
	rating: require('react').PropTypes.number.isRequired,
	maxStars: require('react').PropTypes.number.isRequired
};
DoctifyStarRating.defaultProps = {
	maxStars: 0,
	rating: 0
};

exports.default = DoctifyStarRating;